export const FontFamily_Regular =
  'Oxygen, Segoe, Futura, Helvetica, Roboto, sans-serif';
export const FontFamily_Serif = 'Lora, Georgia, serif';
